import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"

import { rhythm } from "@utils/typography"

const Keyline = styled.div`
  display: block;
  border: 1px solid
    ${props => (props.colour ? props.colour : props.theme.color)};
  margin-bottom: 1.6rem;
`

const KeylineDash = styled(Box)`
  ${props =>
    props.direction === "vertical" ? "border-right" : "border-bottom"}: 3px
    dashed
    ${props => (props.colour ? props.colour : props.theme.colours.secondary)};
  margin: ${props =>
    props.direction === "vertical" ? `0 ${rhythm(1)}` : `${rhythm(1)} 0`};
`

export { Keyline, KeylineDash }
